export default __webpack_public_path__ + "static/media/menu.833912f4.svg";